import { CdkScrollable } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { TranslateModule } from '@ngx-translate/core';

export const MODULES = [
  CommonModule,
  MatDialogModule,
  MatChipsModule,
  MatButtonModule,
  TranslateModule,
];
export const DIRECTIVES = [CdkScrollable];

@Component({
  selector: 'app-dialog-summarize-user',
  templateUrl: 'dialog-summarize-user.component.html',
  imports: [...MODULES, ...DIRECTIVES],
})
export class DialogSummarizeUserComponent {
  private injectedData = inject(MAT_DIALOG_DATA);
  public data = signal(this.injectedData);
}
